import React from "react";
import FirstComponents from "./FirstComponent";
import SecondComponent from "./SecondComponent";
import ThirdComponent from "./ThirdComponent";
import FourthCoponent from "./FourthCoponent";
import Fith from "./Fith";

const FoodBooking = () => {
  return (
    <div>
      <FirstComponents />
      <SecondComponent />
      <ThirdComponent />
      <FourthCoponent />
      <Fith />
    </div>
  );
};

export default FoodBooking;
